import React from "react";
import Navbar from "./components/Navbar";
import CursorCat from "./components/CursorCat";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Skills from "./pages/Skills";
import Education from "./pages/Education";

import Certifications from "./pages/Certifications";
import Contact from "./pages/Contact";
import "./App.css";

function App() {
  return (
    <div className="App">
      <CursorCat />
      <Navbar />
      <section id="home">
        <Home />
      </section>
      <section id="about">
        <About />
      </section>
      <section id="projects">
        <Projects />
      </section>
      <section id="skills">
        <Skills />
      </section>
      <section id="education">
        <Education />
      </section>
      <section id="certifications">
        <Certifications />
      </section>
      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}

export default App;